import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';

export function createAppQueries(client: StoxlyClient) {
  return createQueryKeys('app', {
    // ['app', 'hello']
    hello: {
      queryKey: null,
      queryFn: ({ signal }) => client.appGetHello({ signal }),
    },
  });
}
